// Import necessary modules
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create common API
const commonAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'commonAPI',
    endpoints: (builder) => ({

        getAllTimeLogActivity: builder.query({
            query: () => ({
                url: `/Common/GetAllTimeLogActivity`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTimeLogSubActivity: builder.mutation({
            query: (timeLogActivityId) => ({
                url: `/Common/GetAllTimeLogSubActivity`,
                method: 'POST',
                body: transformRequest(timeLogActivityId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllSourceControlList: builder.query({
            query: () => ({
                url: `/Common/GetAllSourceControlList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

// Destructuring commonAPI to get specific query hooks
export const {
    useLazyGetAllTimeLogActivityQuery,
    useGetAllTimeLogSubActivityMutation,
    useLazyGetAllSourceControlListQuery,
} = commonAPI;

export default commonAPI; // Exporting commonAPI
